import createCollectionResource from 'src/actions/shared/createResource';
import SmsConfiguration from 'src/models/Channels/SmsConfiguration';

const smsConfigurationResource = createCollectionResource<SmsConfiguration>({
  name: 'smsConfiguration',
  endpoint: 'v1/orgs/:orgId/sms-configuration/:id',
  type: SmsConfiguration,
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
        },
        onReplaceSuccess(item) {
          if (item) {
            dispatch(actions.broadcast(item));
          }
        },
        onAddSuccess(item) {
          if (item) {
            dispatch(actions.broadcast(item));
          }
        },
      };
    };
  },
});

export default smsConfigurationResource;
